import * as notificationsRoutines from './notificationsRoutines';
import produce from 'immer';

const notificationsReducer = (
    state = {
        data: [],
        status: [],
        stats:null
    },
    action,
) => {
    switch (action.type) {
        case notificationsRoutines.syncNotifications.SUCCESS:
            return produce(state, draft => {
                draft.data = action.payload ? action.payload.data : {};
                draft.status = action.payload ? action.payload.status : {};
            });

        case notificationsRoutines.getStatsForPushNotifications.SUCCESS:
            return produce(state, draft => {
                draft.stats = action.payload
            });
        default:
            return state;
    }
};
export default notificationsReducer;
